import React, { useState } from "react";
import Feat01 from "../../../assets/images/trust.png";
import { Link } from "react-router-dom";
import { Range } from "react-range";

const Featuresone = () => {
  const [loanAmount, setLoanAmount] = useState(60000);
  const [loanDuration, setLoanDuration] = useState(6);

  const calculateMonthlyPayment = (amount, months) => {
    const interestRate = 0.15;
    const totalInterest = amount * interestRate;
    const totalPayBack = amount + totalInterest;
    const monthlyPayment = totalPayBack / months;
    return {
      monthlyPayment: monthlyPayment.toFixed(2),
      totalPayBack: totalPayBack.toFixed(2),
    };
  };

  const { monthlyPayment, totalPayBack } = calculateMonthlyPayment(
    loanAmount,
    loanDuration
  );

  return (
    <section className="features-section-one">
      <div className="container-fluid">
        <div className="row align-items-center">
          
          {/* Left Image Column */}
          <div className="col-12 col-sm-10 col-md-6 col-xl-4 mb-4 mb-xl-0">
            <div className="features-one-image text-center text-xl-start">
              <img src={Feat01} alt="features-image" className="img-fluid" />
              <div className="image-shape">
                <span />
                <span />
              </div>
            </div>
          </div>
          
          {/* Right Text Column */}
          <div className="col-12 col-md-6 col-xl-7 px-5">
            <div className="features-one-info px-3 px-md-4 px-lg-5">
              <div className="heading-box mb-4">
                <h2 className="heading-title nri" id="why-seperate">
                  Why NRIs trust The NRI Advisors?
                </h2>
              </div>

              <div className="features-one-list-block">
                <ul className="features-one-list">
                  <li>PAN-India Service</li>
                  <li>100% Transparency</li>
                  <li>Confidentiality & Professionalism.</li>
                  <li>Regular Team Follow-Ups.</li>
                  <li>Dedicated Case Management.</li>
                  <li>Global support with Indian execution.</li>
                  <li>24/7 availability in all time zones</li>
                  <li>Minimum travel needed — we manage everything for you remotely</li>
                  <li>Trusted hub for legal, financial, property, and documentation</li>
                  <li>Transparent pricing and guaranteed process clarity</li>
                </ul>
              </div>

              <Link to="/contact-us" className="btn btn-secondary mt-3">
                Get Started
                <i className="flaticon-next ms-2" />
              </Link>
            </div>
          </div>
          {/* <div className="col-xxl-3 col-xl-4 col-lg-6 col-md-8 col-sm-10">
            <form
              action="#"
              id="loan-calculator"
              className="features-one-form wow fadeInUp animated animated"
              data-wow-duration="2000ms"
              data-wow-delay="500ms"
            >
              <h3>How much do you need?</h3>
              <div className="features-one-form-content">
                <div className="input-box__top">
                  <span>$10,000</span>
                  <span>$100,000</span>
                </div>

                <Range
                  step={1000}
                  min={10000}
                  max={100000}
                  values={[loanAmount]}
                  onChange={(values) => setLoanAmount(values[0])}
                  renderTrack={({ props, children }) => (
                    <div
                      {...props}
                      style={{
                        ...props.style,
                        height: "10px",
                        width: "100%",
                        backgroundColor: "#f6f6f6",
                        borderRadius: "4px",
                        position: "relative",

                      }}
                    >
                      <div
                        style={{
                          position: "absolute",
                          height: "10px",
                          backgroundColor: "black",
                          borderRadius: "4px",
                          left: "0%",
                          width: `${((loanAmount - 10000) / (100000 - 10000)) * 100}%`,
                        }}
                      />
                      {children}
                    </div>
                  )}
                  renderThumb={({ props, key }) => (
                    <div key={key} {...props} style={{ ...props.style, height: "20px", width: "20px", backgroundColor: "#808080", borderRadius: "50%" }} />
                  )}
                  
                />
                <div
                  style={{
                    textAlign: "center",
                    marginTop: "10px",
                    fontSize: "18px",
                    color: "#000",
                  }}
                >
                  ${loanAmount}
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: "10px",
                    fontSize: "16px",
                    color: "#000",
                  }}
                >
                  <span>1 Month</span>
                  <span>12 Months</span>
                </div>

                <Range
                  step={1}
                  min={1}
                  max={12}
                  values={[loanDuration]}
                  onChange={(values) => setLoanDuration(values[0])}
                  renderTrack={({ props, children }) => (
                    <div
                      {...props}
                      style={{
                        ...props.style,
                        height: "10px",
                        width: "100%",
                        backgroundColor: "#f6f6f6",
                        borderRadius: "4px",
                        position: "relative",
                      }}
                    >
                      <div
                        style={{
                          position: "absolute",
                          height: "10px",
                          backgroundColor: "black",
                          borderRadius: "4px",
                          left: "0%",
                          width: `${((loanDuration - 1) / (12 - 1)) * 100}%`,
                        }}
                      />
                      {children}
                    </div>
                  )}
                  renderThumb={({ props }) => (
                    <div
                      {...props}
                      style={{
                        ...props.style,
                        height: "20px",
                        width: "20px",
                        backgroundColor: "#808080",
                        borderRadius: "50%",
                      }}
                    />
                  )}
                />
                <div
                  style={{
                    textAlign: "center",
                    marginTop: "10px",
                    fontSize: "18px",
                    color: "#000",
                  }}
                >
                  {loanDuration}
                </div>

                <p>
                  <span>Pay Monthly</span>
                  <b>${monthlyPayment}</b>
                </p>
                <p>
                  <span>Total Pay Back</span>
                  <b>${totalPayBack}</b>
                </p>
                <button type="submit" className="btn btn-primary btn-block">
                  Apply For Loan
                </button>
              </div>
            </form>
          </div> */}
        </div>
      </div>
    </section>
  );
};

export default Featuresone;